import WyAutoQAHomePage from '../components/autoQA/wy-auto-qa-home-page.vue'
import WyAutoQAEvaluationGroupsTeamsPage from '../components/autoQA/wy-auto-qa-evaluation-groups-teams-page.vue'
import WyAutoQAEvaluationAgentPage from '../components/autoQA/wy-auto-qa-evaluation-agents-page.vue'
import WyAutoQAAiEvaluationPage from '../components/autoQA/wy-auto-qa-ai-evaluation-page.vue'
import WyAutoQAAiEvaluationSummaryPage from '../components/autoQA/wy-auto-qa-ai-evaluation-summary-page.vue'
import WyAutoQAAiEvaluationFormManagerPage from '../components/autoQA/wy-auto-qa-ai-evaluation-form-manager-page.vue'
import WyEvaluationNewFormPage from '../components/autoQA/wy-evaluation-new-form.vue'
import WyAutoQAAiEvaluationQuestionManagerPage from '../components/autoQA/wy-auto-qa-ai-evaluation-question-manager-page.vue'
import WyEvaluationNewQuestionPage from '../components/autoQA/wy-evaluation-new-question.vue'


export default [
  {
    path: '/autoQA',
    name: 'autoQAHome',
    component: WyAutoQAHomePage,
    meta: { 
      bindModel: 'chat-autoQA',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'formId', 'directions', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        {name:'form-filter-dropdown-widget'},
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'interactions-filtering-widget'}
      ]
    }
  },
  {
    path: '/autoQAEvaluation',
    name: 'autoQAEvaluationGroupsTeams',
    component: WyAutoQAEvaluationGroupsTeamsPage,
    props: true,
    meta: { 
      bindModel: 'chat-autoQA',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'formId', 'directions', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        {name:'form-filter-dropdown-widget'},
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'interactions-filtering-widget'}
      ]
    }
  },
  {
    path: '/autoQAEvaluationAgent',
    name: 'autoQAEvaluationAgent',
    component: WyAutoQAEvaluationAgentPage,
    props: true,
    meta: { 
      bindModel: 'chat-autoQA',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'formId', 'directions'],
      headerMenuItems: [
        {name:'form-filter-dropdown-widget'},
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'}
      ]
    }
  },
  {
    path: '/autoQA/aiEvaluation',
    name: 'aiEvaluation',
    component: WyAutoQAAiEvaluationPage,
    meta: {
      isIFramePage: true
    }
  },
  {
    path: '/autoQA/aiEvaluationSummary',
    name: 'aiEvaluationSummary',
    component: WyAutoQAAiEvaluationSummaryPage,
    meta: {
      isIFramePage: true
    }
  },
  {
    path: '/autoQA/aiEvaluationFormManager',
    name: 'aiEvaluationFormManager',
    component: WyAutoQAAiEvaluationFormManagerPage,
    meta: {
      isIFramePage: true
    }
  },
  {
    path: '/autoQA/evaluationNewForm',
    name: 'evaluationNewForm',
    component: WyEvaluationNewFormPage,
    meta: {
      isIFramePage: true
    }
  },
  {
    path: '/autoQA/aiEvaluationQuestionManager',
    name: 'aiEvaluationQuestionManager',
    component: WyAutoQAAiEvaluationQuestionManagerPage,
    meta: {
      isIFramePage: true
    }
  },
  {
    path: '/autoQA/evaluationNewQuestion',
    name: 'evaluationNewQuestion',
    component: WyEvaluationNewQuestionPage,
    meta: {
      isIFramePage: true
    }
  },
]